import React from 'react';
import { useParams } from 'react-router-dom';

import AssignmentCreateForm from 'components/Assignment/AssignmentCreateForm/AssignmentCreateForm';

const AssignmentCreatePage: React.FC = () => {
  const { accountId = '', projectId = '', positionId = '' } = useParams();

  return <AssignmentCreateForm accountId={accountId} projectId={projectId} positionId={positionId} />;
};

export default AssignmentCreatePage;
